<template>
  <div>
    <a-result status="warning" title="服务器出了点问题,请检查一下网络连接">
      <template #extra>
        <a-button key="console" type="primary" @click="goHome">
          尝试回首页
        </a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goHome() {
      this.$router.replace("/train/project-list");
      localStorage.clear()
    },
  },
};
</script>

<style lang="scss" scoped>
</style>